/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Import_Csv_Description_AppendInputs */



/**
* | output |
* | --- |
* | "Rows are appended to the table. Every column in the CSV header must already exist in the table, and each value must match that column's type. A single invali..." |
*
* @param {Datasets_Import_Csv_Description_AppendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_description_append = /** @type {((inputs?: Datasets_Import_Csv_Description_AppendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Description_AppendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Zeilen werden an die Tabelle angehängt. Jede Spalte der CSV-Kopfzeile muss in der Tabelle bereits vorhanden sein, und jeder Wert muss zum Typ dieser Spalte passen. Eine einzige ungültige Zeile weist die gesamte Datei zurück.")
	return /** @type {LocalizedString} */ ("Rows are appended to the table. Every column in the CSV header must already exist in the table, and each value must match that column's type. A single invalid row rejects the whole file.")
});